/**
 * External dependencies.
 */
import React from 'react';

/**
 * DropdownIcon Component.
 *
 * @return {jsx}
 */
const DropdownIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="10" height="5" viewBox="0 0 10 5">
		<path fillRule="evenodd" d="M0 0L5 5 10 0z"/>
	</svg>
);

export default DropdownIcon;
